import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { Grid, Table, TableCell, TableRow } from '@mui/material';
import { DetailsTableItem, IExamineeInfoDto } from './ExamineeDetails.types';
import { SelectableTableColumn } from '../SelectableTable/SelectableTable.types';
import { useStyles } from './ExamineeDetails.styles';
import { getCandidateCardStatus } from '../../pages/ExamineeList/ExamineeListTable/GetExamineeCardStatus/GetExamineeCardStatus.component';
import { getCommitteeLabel } from '../../models/committees.types';
import { ExamineeStatus } from '../../pages/ExamineeList/ExamineeList.types';

interface IExamineeInfo {
  onClose?: () => void;
  data: IExamineeInfoDto;
}

interface ITableData {
  label: string;
  value: string | number | JSX.Element | string[];
}

interface ITableVertical {
  title: string;
  data: ITableData[];
}

export const setValueIfNullString = (value: string) => {
  return value !== null && value !== '' ? value : '-';
  }

export const setValueIfNullArray = (value: string[]) => {
  return value.length > 0 ? value : '-';
  }

const TableVertical: React.FC<ITableVertical> = ({ title, data }) => {
  //TODO will be moving to separate component
  const classes = useStyles();

  return (
    <>
      <div className={classes.subTitle}>{title}</div>
      <Table className={classes.tableRow}>
        {data.map((cell:ITableData ) => {
          return (
            <TableRow key={cell.label}>
              <TableCell variant="head" style={{ fontWeight: 700, width: '40%' }}>
                {cell.label}
              </TableCell>
              <TableCell>{cell.value}</TableCell>
            </TableRow>
          );
        })}
      </Table>
    </>
  );
};

export const ExamineeInfo: React.FC<IExamineeInfo> = ({ onClose, data }) => {
  const { t } = useTranslation();
  useDocumentTitle('Informacje podstawowe');
  const classes = useStyles();

  const item = data;

  const transformedDataExam = [
    { label: 'Nazwa egzaminu', value: setValueIfNullString(item.examName)},
    { label: 'Kod arkusza', value: setValueIfNullString(item.sheetCode) },
    { label: 'Dostosowane kryteria oceniania', value: item.adjustmentEnabled !== null && item.adjustmentEnabled ? 'TAK' : 'NIE' },
    { label: 'Sala', value: setValueIfNullString(item.room) },
  ];

  const transformedDataComitAndExaminee = [
    { label: 'Komisja egzaminacyjna', value: setValueIfNullString(getCommitteeLabel(item.examCommittee)) },
    { label: 'ID Szkoły', value: setValueIfNullString(item.schoolCode)},
    { label: 'Kod zdającego', value: setValueIfNullString(item.examineeCode) },
    { label: 'PESEL', value: setValueIfNullString(item.pesel) },
    { label: 'Numer dokumentu', value: setValueIfNullString(item.documentNumber)},
  ];

  const transformedDataAdjust = [
    { label: 'Sposoby dostosowań', value: setValueIfNullArray (item.adjustmentTypes.map((item) => `${item}, `))},
    { label: 'Uprawnienia do dostosowań', value:setValueIfNullArray (item.adjustmentPermissions.map((item) => `${item}, `)) },
  ];

  const transformedDataStatus = [
    { label: 'Status egzaminu', value: getCandidateCardStatus(item.taskSolutionSheetCompleted ? ExamineeStatus.Completed : ExamineeStatus.Empty, false, true) },
  ];

  return (
    <>
      <Grid item xs={12}>
        <div className={classes.tabTitle}>Informacje podstawowe</div>

        <TableVertical title="Szczegóły egzaminu" data={transformedDataExam} />
        <TableVertical title="Informacje o komisji i zdającym" data={transformedDataComitAndExaminee} />
        <TableVertical title="Informacje o dostosowaniach" data={transformedDataAdjust} />
        <TableVertical title="Status przetwarzania karty" data={transformedDataStatus} />
      </Grid>
    </>
  );
};
